<template>
    <div>
        <div v-for="(item, index) in menus" style="text-align: center;" :key="index">
            <!-- 如果只是一级菜单。 -->
            <drop-tip :item="item" v-if="!hasChildren(item)" />
            <Dropdown  v-else  placement="right" :key="index" @on-click="active=>$emit('on-select', active)">
                <Button  class="btn-dropmenu" type="text">
                    <Icon :size="20" :color="color" :type="item.icon" />
                </Button>
                <drop-menu :item="item" slot="list" />
            </Dropdown>
        </div>
    </div>
</template>
<script>
import DropTip from './sider-dropdown/droptip.vue'
import DropMenu from './sider-dropdown/dropmenu.vue'
import {mixins} from './sider'

export default {
    components:{DropTip,DropMenu},
    mixins:[mixins],
}
</script>
